(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyToasts", [
    "ToastManager",
    "$window",
    "$timeout",
    "$sce",
    function (ToastManager, $window, $timeout, $sce) {
      var controller = function () {
        var ctl = this;
        ctl.toasts = [];
        ctl.isVisible = true;

        ctl.removeToast = function (toast) {
          if (toast.timeout) {
            $window.clearTimeout(toast.timeout);
          }

          $timeout(function () {
            ctl.toasts.splice(ctl.toasts.indexOf(toast), 1); // remove it
          });
        };

        ctl.addToast = function (message, timeout, group, hideOnDesktop, passthroughHtml) {
          var newToast;
          var hideToastSoon = function () {
            ctl.removeToast(newToast);
          };

          /* eslint-disable no-param-reassign */
          hideOnDesktop = typeof hideOnDesktop !== "undefined" ? hideOnDesktop : false;
          /* eslint-enable no-param-reassign */

          newToast = {
            timeout: timeout ? $window.setTimeout(hideToastSoon, timeout) : null,
            message: message,
            group: group,
            class: hideOnDesktop ? "hidden-md hidden-lg" : "",
            passthroughHtml: passthroughHtml,
          };

          $timeout(function () {
            ctl.toasts.unshift(newToast); // insert at index 0
          });

          return newToast;
        };

        ctl.removeToastsByGroup = function (group) {
          $timeout(function () {
            ctl.toasts
              .filter(function (toast) {
                return typeof group === "undefined" || toast.group === group;
              })
              .forEach(function (toast) {
                ctl.removeToast(toast);
              });
          });
        };

        ctl.toTrusted = function (html_code) {
          return $sce.trustAsHtml(html_code);
        };

        ToastManager.registerController(ctl);
      };

      return {
        restrict: "E",
        scope: {},
        bindToController: {
          message: "@message",
        },
        controller: controller,
        controllerAs: "ctrl",
        // prettier-ignore
        template:
          '<div class="ty-toasts" data-ty-stick-to-top>' +
            '<div class="ty-toast-container" data-ng-repeat="toast in ctrl.toasts">' +
              '<div class="ty-toast-spacing"></div>' +
              '<div class="ty-toast {{toast.class}}">' +
                '<span class="ty-toast__message" data-ng-if="!toast.passthroughHtml" data-ng-bind="toast.message"></span>' +
                '<span class="ty-toast__message" data-ng-if="toast.passthroughHtml" data-ng-bind-html="ctrl.toTrusted(toast.message)"></span>' +
                '<span class="ty-toast__close" data-ng-click="ctrl.removeToast(toast)">' +
                  '<ty-svg-icon icon-id="close-light"></ty-svg-icon>' +
                "</span>" +
              "</div>" +
            "</div>" +
          "</div>",
        link: function (scope, element) {
          element.insertAfter(angular.element("body > header, .ty-secondary-nav").last());
        },
      };
    },
  ]);
})(window.angular);
